import { createClassed } from "@tw-classed/react";
import { twMerge } from "cn";

export const { classed } = createClassed({ merger: twMerge });
